import React, { Component } from "react";
import { connect } from "react-redux";
import { Input } from "../../../Form";
import { BoxTitle, Box } from "../../../PageTemplate";
import { handleChange, updateTimeout } from "./utils";

class Name extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventID: null,
      eventData: {},
      fields: {},
      error: {
        name: false,
        subtitle: false,
        website: {
          title: false,
        },
      },
      eventFinised: false,
    };

    this.updateTimeoutID = null;

    this.handleChange = handleChange.bind(this);
    this.updateTimeout = updateTimeout.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const { eventFinised } = props;
    const events = props.events.list;
    const eventID = props.events.currentEventID;
    const newState = {};
    const newStateData = {};
    const newStateFields = {};

    if (!events || !events[eventID]) return null;
    const { name, website, subtitle } = events[eventID];

    if (eventID && eventID !== state.eventID) newState.eventID = eventID;
    if (eventFinised && eventFinised !== state.eventFinised)
      newState.eventFinised = eventFinised;

    if (name && name !== state.eventData.name) {
      newStateData.name = name;
      if (!state.fields.name) newStateFields.name = name;
    }

    if (subtitle && subtitle !== state.eventData.subtitle) {
      newStateData.subtitle = subtitle;
      if (!state.fields.subtitle) newStateFields.subtitle = subtitle;
    }

    const propTitle = website && website.title;
    const stateTitle = state.eventData.website && state.eventData.website.title;
    if (propTitle && propTitle !== stateTitle) {
      newStateData.website = { title: website.title };
      if (!state.fields.website)
        newStateFields.website = { title: website.title };
    }

    if (Object.keys(newStateData).length > 0) newState.eventData = newStateData;
    if (Object.keys(newStateFields).length > 0)
      newState.fields = { ...state.fields, ...newStateFields };
    if (Object.keys(newState).length > 0) return newState;

    return null;
  }

  validation() {
    const { name, website, subtitle } = this.state.fields;

    var err = {
      name: name.trim().length < 5 || name > 200,
      subtitle: subtitle.trim().length < 5 || subtitle > 200,
      website: {
        title: (website && website.title.length) > 200,
      },
    };

    this.setState({ error: { ...this.state.error, ...err } });

    const hasError = JSON.stringify(err);
    return hasError.indexOf(true) === -1;
  }

  render() {
    const { name, website, subtitle } = this.state.fields;

    return (
      <Box col="1">
        <BoxTitle icon="faCogs">שם</BoxTitle>
        <Input
          name="name"
          value={name || ""}
          placeholder="כותרת האירוע:"
          error={this.state.error.name}
          errorText="כותרת האירוע לא תקין"
          onChange={this.handleChange}
          label={true}
          disabled={this.state.eventFinised}
        />
        <Input
          name="subtitle"
          value={subtitle || ""}
          placeholder="תת כותרת:"
          error={this.state.error.subtitle}
          errorText="תת כותרת לא תקין"
          onChange={this.handleChange}
          label={true}
          disabled={this.state.eventFinised}
        />
        <Input
          name="website.title"
          value={(website && website.title) || ""}
          placeholder="כותרת עמוד הסלפי:"
          error={this.state.error.website.title}
          errorText="עד 200 תווים"
          onChange={this.handleChange}
          label={true}
          disabled={this.state.eventFinised}
        />
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    events: state.eventsReducer,
  };
};

const NameWithRedux = connect(mapStateToProps)(Name);

export { NameWithRedux as Name };



// WEBPACK FOOTER //
// ./src/components/EventPage/settings/event/Name.jsx